import { useContext } from 'react';

import { PayPalScriptProvider } from '@paypal/react-paypal-js';

import { ProvidersLibsContext } from '@/services/providersLibs/providersLibsContext';

function PaypalContainer({ children, enabled }: React.PropsWithChildren<{ enabled: boolean }>) {
  const providersLibs = useContext(ProvidersLibsContext);

  const paypalOptions = providersLibs?.paypalOptions;

  if (!enabled || !paypalOptions) {
    return children;
  }

  return (
    <PayPalScriptProvider options={paypalOptions}>
      {children}
    </PayPalScriptProvider>
  );
}

export default PaypalContainer;
